import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Search {
  constructor() {
    _defineProperty(this, "gambits", {});
  }
  gambit(modelType, gambit) {
    this.gambits[modelType] ||= [];
    this.gambits[modelType].push(gambit);
    return this;
  }
  extend(app, extension) {
    for (const [modelType, gambits] of Object.entries(this.gambits)) {
      for (const gambit of gambits) {
        app.search.gambits.gambits[modelType] ||= [];
        app.search.gambits.gambits[modelType].push(gambit);
      }
    }
  }
}
flarum.reg.add('core', 'common/extenders/Search', Search);